import { Box } from "@mui/joy";
import { useEffect, useState } from "react";

import { useProject } from "../../../../hooks/query";
import { MultiProgressBar } from "../../../../shared";

export function StatusGraph() {
    const { useGetProjectStatusSummary } = useProject();
    const projectStatusSvc = useGetProjectStatusSummary();

    const [graphData, setGraphData] = useState<any>([]);
    const [isSmall, setIsSmall] = useState(window.innerWidth < 700);

    useEffect(() => {
        const handleResize = () => setIsSmall(window.innerWidth < 700);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (projectStatusSvc.data) {
            const responseData = projectStatusSvc.data;
            setGraphData([
                {
                    label: isSmall ? "NS" : "Not Started",
                    count: responseData["NOT-STARTED"] ?? 0,
                    color: "#F44336",
                },
                {
                    label: isSmall ? "IP" : "In Progress",
                    count: responseData["IN-PROGRESS"] ?? 0,
                    color: "#1976D2",
                },
                {
                    label: isSmall ? "DONE" : "Completed",
                    count: responseData["COMPLETED"] ?? 0,
                    color: "#4CAF50",
                },
                {
                    label: isSmall ? "CNCL" : "Cancelled",
                    count: responseData["CANCELLED"] ?? 0,
                    color: "#B0BEC5",
                },
            ]);
        }
    }, [projectStatusSvc.data, isSmall]);

    return (
        <Box>
            <MultiProgressBar statusData={graphData} />
        </Box>
    );
}
